import { render, staticRenderFns } from "./UnitDetail.vue?vue&type=template&id=1ac808b6&"
import script from "./UnitDetail.vue?vue&type=script&lang=js&"
export * from "./UnitDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!E:/CBK/PPC/WMS/v1.23.6/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDatePicker } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBreadcrumbs,VBtn,VCard,VContainer,VDatePicker,VFlex,VForm,VIcon,VLayout,VMenu,VSwitch,VTextField})
